import React from 'react';
import { YesNoBadge } from '../common/forms/FormElements';
import cls from 'classnames';
import { isAlwaysAvailable } from './ContractPhase';
import { PhaseMaterialPopover } from './PhaseMaterialPopover';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

export default class ContractPhaseRow extends React.Component {
    constructor(props) {
        super(props);

        this.state = { showModal: false };
    }

    toggleModal = () => {
        const { showModal } = this.state;
        this.setState({ showModal: !showModal });
    };

    phaseIsActiveButUnavailable = (phase) =>
        Boolean(
            !phase.unitOfMeasure && phase.isActive && !isAlwaysAvailable(phase)
        );

    phaseIsActiveButHidden = (phase) =>
        !this.phaseIsActiveButUnavailable(phase) &&
        Boolean(phase && phase.isActive && phase.isHidden);

    onToggleUpdateClick = (e) => {
        const { onContractPhaseHideToggleClick, contractPhase } = this.props;

        onContractPhaseHideToggleClick({
            contractPhaseId: contractPhase.id,
        });

        this.toggleModal();
    };

    render() {
        const { showModal } = this.state;
        const { contractPhase, phaseMaterials, heavyBidMaterials } = this.props;

        const associatedPhaseMaterials = phaseMaterials.filter(
            (pm) => pm.contractPhaseId == contractPhase.id
        );

        const scheduledQuantity = Number(contractPhase.scheduledQuantity);

        const quantity = Number(contractPhase.quantity);

        const isTargetingMoreThanBid =
            scheduledQuantity > 0 && scheduledQuantity > quantity;

        return (
            <>
                <tr
                    key={contractPhase.id}
                    className={cls({
                        'light-warning-background':
                            this.phaseIsActiveButUnavailable(contractPhase),
                        'light-info-background':
                            this.phaseIsActiveButHidden(contractPhase),
                    })}
                >
                    <td>{contractPhase.displayPhase}</td>
                    <td>
                        {contractPhase.description}

                        {contractPhase.isHidden && (
                            <FontAwesomeIcon
                                icon={faEyeSlash}
                                className="ml-1"
                                title="This phase is configured to be hidden."
                            />
                        )}

                        <div className="float-right">
                            <PhaseMaterialPopover
                                contractPhaseId={contractPhase.id}
                                associatedPhaseMaterials={
                                    associatedPhaseMaterials
                                }
                                heavyBidMaterials={heavyBidMaterials}
                            />
                        </div>
                    </td>
                    <td>{contractPhase.unitOfMeasure}</td>
                    <td>{contractPhase.quantity}</td>
                    <td
                        className={cls({
                            'text-danger': isTargetingMoreThanBid,
                            'font-weight-bold': isTargetingMoreThanBid,
                        })}
                    >
                        {contractPhase.scheduledQuantity}
                    </td>
                    <td>
                        <YesNoBadge value={contractPhase.isActive} />
                    </td>
                    <td>
                        <YesNoBadge value={contractPhase.isHidden} />

                        <Button
                            type="button"
                            color="info"
                            onClick={this.toggleModal}
                            outline
                            size="sm"
                            className="ml-2"
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                    </td>
                </tr>

                <Modal
                    isOpen={showModal}
                    toggle={this.toggleModal}
                    fade={false}
                    centered={true}
                    size="xl"
                >
                    <ModalHeader toggle={this.toggleModal}>
                        {contractPhase.displayPhase} -{' '}
                        {contractPhase.description}
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            {contractPhase.displayPhase} -{' '}
                            {contractPhase.description}{' '}
                            {contractPhase.isHidden && (
                                <span className="font-weight-bold">is</span>
                            )}
                            {!contractPhase.isHidden && <span>is not</span>}{' '}
                            hidden from use.
                        </div>

                        <div>
                            If you would like to change that, click the button
                            below
                        </div>

                        <div>
                            <Button
                                color="danger"
                                onClick={this.onToggleUpdateClick}
                            >
                                {contractPhase.isHidden && (
                                    <>Un-hide {contractPhase.description}</>
                                )}
                                {!contractPhase.isHidden && (
                                    <>Hide {contractPhase.description}</>
                                )}
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>
            </>
        );
    }
}
